// extracted by mini-css-extract-plugin
export default {"container":"contentcozy_container__M0fyS","header":"contentcozy_header__xcVUO","text":"contentcozy_text__A5OIs","btn":"contentcozy_btn__evEgi"};